import { Input, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useValidationErrorsStore } from '@hero/components/providers/ValidationErrorsProvider';
import { constants } from '@hero/configs';
import { GIFT_MESSAGE, MAX_SENDER_NAME_LENGTH } from '@hero/constants';
import { formatNumber } from '@hero/utils';

import { GiftMessageArea } from './GiftMessageArea';
import * as S from './style';

function GiftMessageInputs({
  senderName,
  setSenderName = () => {},
  message,
  setMessage,
  setOccasion,
  customMessageLength,
  shortcutTagsActive = true,
  renderCustomizeMessageModal
}) {
  const { errors } = useValidationErrorsStore();
  const { t } = useTranslation();

  return (
    <S.GiftMessageInputs id={GIFT_MESSAGE}>
      <Typography variant="body1Bold">{t('writeGiftMessage')}:</Typography>
      <S.InputArea>
        <Input
          name="senderName"
          label={
            <>
              {t('senderName')} <S.Required>*</S.Required>
            </>
          }
          value={senderName}
          variant="outlined"
          onChange={e => setSenderName(e.target.value)}
          inputProps={{
            maxLength: MAX_SENDER_NAME_LENGTH,
            validations: {
              required: {
                required: true,
                message: t('inputEmptyWarning', { name: t('senderName') })
              }
            }
          }}
          helperText={
            <Typography variant="caption1" emphasis="weaker" color="inherit">
              {t('lengthCharacters', {
                length: formatNumber(senderName?.length),
                limit: MAX_SENDER_NAME_LENGTH
              })}
            </Typography>
          }
          error={errors?.warning?.find(e => e.key === 'getSenderNameRule')}
        />
        <GiftMessageArea
          textAreaProps={{
            onChange: setMessage,
            value: message,
            limit: constants?.general?.giftMessageLimit
          }}
          footerProps={{
            setOccasion,
            setMessage,
            customMessageLength,
            tagActive: shortcutTagsActive,
            customizeActive: shortcutTagsActive,
            renderCustomizeMessageModal
          }}
          error={errors?.warning?.find(e => e.key === 'getMessageRule')}
        />
      </S.InputArea>
    </S.GiftMessageInputs>
  );
}

export { GiftMessageInputs };
